export default __webpack_public_path__ + "static/media/ski2.f908cee3.webp";